<template>
  <div style="height: calc(100% - 40px);">
    <div class="im-chat-main" style="height: 100%">
      <div id="his-chat-message" class="messages" style="height: 100%;overflow-x: hidden;">
        <ul class="message-list">
          <template v-for="(item, index) in hisMessageList">
            <li
                v-if="item.ifRevoke !== '1'"
                :key="index"
                :class="{ 'message-item':true }"
                @click="()=>handleToHistoryList(item)"
            >
              <div id="historyMessageBox" class="im-chat-user">
                <img :src="item.avatar" v-if="item.avatar" alt="头像"/>
                <Icon type="ios-contact" v-else size="40"/>
<!--                <div v-if="item.mine" class="message-info">-->
<!--                  <i>{{ item.timestamp }}</i>-->
<!--                  <span>{{ item.username }}</span>-->
<!--                </div>-->
                <div class="message-info">
                  <span>{{ item.username }}</span>
                  <i>{{ item.timestamp }}</i>
                </div>
              </div>
              <div :class="['im-chat-text',{'is-file': isFile(item.content)}]" @click="openImageProxy($event)"
                   v-html="formatMessage(item.content)">
              </div>
            </li>
            <li v-else class="im-chat-back">
              {{item.mine ? '您':'对方'}}撤回了一条消息
            </li>
          </template>
        </ul>
      </div>
    </div>
    <Page
        :current.sync="pageNo"
        :page-size="pageSize"
        :total="count"
        class="page"
        show-total
        size="small"
        @on-change="getHistoryMessage"
    />
  </div>
</template>

<script>
import RequestUtils from "@/utils/RequestUtils";
import conf from "@/views/im/conf";
import {imageLoad, transform} from "../../../utils/ChatUtils";
import exe from "../../../static/exe.png"
import pdf from "../../../static/pdf.png"
import excel from "../../../static/excel.png"
import files from "../../../static/files.png"
import apk from "../../../static/apk.png"
import word from "../../../static/word.png"

export default {
  name: "history-message",
  props: {
    showHistory: {
      type: Boolean,
      default: false
    },
    chat: {
      type: Object,
      default: null
    },
    search: {
      type: String,
      default: ""
    },
    openSearch: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      host: conf.getHostUrl(),
      count: 0,
      pageSize: 20,
      hisMessageList: [],
      pageNo:4,
    };
  },
  watch: {
    showHistory: function (show) {
      this.showHistory = show;
      if (show) {
        this.pageNo = 1
        this.getHistoryMessage(1);
      }else {
        this.pageNo = 1
      }
      window.parent.postMessage({
        type: "hiddenClose",
        content: show
      }, "*")
    },
    openSearch: function (val) {
      if (val) {
        this.getHistoryMessage(1)
      }
    }
  },
  mounted() {
  },
  methods: {
    handleToHistoryList(item) {
      let formData = new FormData()
      formData.append("chatId",item.chatId)
      formData.append("chatType",item.type)
      formData.append("fromId",item.fromId)
      formData.append("msgId",item.cid)
      RequestUtils.request(conf.getMessageRows(),formData).then(res=>{
        let pageNo = Math.ceil(res.rownum / 20)
        this.$emit("updateMessageList",{
          pageNo:pageNo,
          cid:item.cid
        })
      })
    },
    getFileType(file) {
      return file.substring(file.lastIndexOf(".") + 1);
    },
    getTemplate(fileUrl, filename, fileIcon) {
      return `
        <div style="display:flex;cursor:pointer;background-color:#fff;padding: 5px 10px;border-radius: 5px;align-items: center;" data-url="${fileUrl}">
          <div class="img" style="width:40px;" data-url="${fileUrl}">
            <img style="width:40px;height:40px;" src="${fileIcon}" alt="" data-url="${fileUrl}" />
          </div>
          <div class="name" style="flex:1;font-size:14px;font-weight:400;padding-left:5px;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 1;-webkit-box-orient: vertical;color: #333333;" data-url="${fileUrl}">${filename}</div>
        </div>
      `
    },
    isFile(item) {
      let fileReg = /(.*?)class=(.*?message-file.*?)/g;
      return fileReg.test(item);
    },
    htmlResult(fileUrl, filename) {
      const fileType = this.getFileType(fileUrl);
      switch (fileType.toLowerCase()) {
        case "exe":
          console.log("exe");
          return this.getTemplate(fileUrl, filename, exe)
        case "pdf":
          console.log("pdf");
          return this.getTemplate(fileUrl, filename, pdf)
        case "apk":
          return this.getTemplate(fileUrl, filename, apk)
        case 'xls':
        case 'xlsx':
          return this.getTemplate(fileUrl, filename, excel)
        case 'doc':
        case 'docx':
          return this.getTemplate(fileUrl, filename, word)
        default:
          return this.getTemplate(fileUrl, filename, files)
      }
    },
    formatMessage(v) {
      let fileReg = /(.*?)class=(.*?message-file.*?)/g;
      if (fileReg.test(v)) {
        const matchUrl = /href="([^"]*)"/;
        const matchName = /<\/i>(.*?)<\/a>/
        const fileUrl = v.match(matchUrl)[1];
        const name = v.match(matchName)[1]
        if (fileUrl) {
          return this.htmlResult(fileUrl, name);
        }
      } else {
        return v;
      }
    },
    // 附件和图片点击展开
    openImageProxy: function (event) {
      let self = this;
      event.preventDefault();
      if (event.target.nodeName === "IMG" && !event.target.dataset.url) {
        self.winControl.openURL(event.target.src);
      } else if (
          event.target.dataset.url
      ) {
        self.winControl.openURL(event.target.dataset.url);
      }
    },
    getHistoryMessage(pageNo) {
      let self = this;
      if (!pageNo) {
        pageNo = 1;
      }
      this.$emit("restSearchStatus", false)
      let param = new FormData();
      param.set("chatId", self.chat.id);
      param.set("chatType", "0");
      param.set("fromId", self.$store.state.user.id);
      param.set("pageNo", pageNo);
      param.set("keyword", self.search)

      RequestUtils.request(conf.getHisUrl(), param).then(json => {
        let list = json.messageList.map(function (element) {
          element.content = transform(element.content);
          element.timestamp = self.formatDateTime(new Date(element.timestamp));
          return element;
        });
        if(self.search) {
          self.hisMessageList = list.reverse().filter(item => {
            item.content = item.content.replaceAll(self.search, `<span style="font-weight: 600;background-color:rgb(249,226,164);color:#333333">${self.search}</span>`)
            return item
          });
        }else {
          self.hisMessageList = list.reverse()
        }

        self.count = json.count;
        self.pageSize = json.pageSize;
        // 每次滚动到最底部
        self.$nextTick(() => {
          imageLoad("his-chat-message");
        });
      });
    }
  }
};
</script>

<style lang="scss" >
</style>
